import { ChevronsDown, ChevronsUp, CircleCheck, Minus } from 'lucide-react';

import { customPalette } from '@shared/theme/StyleProvider';

export const getAppraisalPerception = (
  appraisalPerception: null | string | undefined,
  appraisalPerceivedValue: null | number | undefined,
  max: null | number | undefined,
  min: null | number | undefined,
  size = 16,
) => {
  if (
    appraisalPerception === 'just_right' ||
    (appraisalPerceivedValue != null &&
      min != null &&
      max != null &&
      min <= appraisalPerceivedValue &&
      max >= appraisalPerceivedValue)
  ) {
    return <CircleCheck size={size} color={customPalette.green500} />;
  } else if (
    appraisalPerception === 'too_low' ||
    (appraisalPerceivedValue != null &&
      max != null &&
      max < appraisalPerceivedValue)
  ) {
    return <ChevronsUp size={size} color={customPalette.red500} />;
  } else if (
    appraisalPerception === 'too_high' ||
    (appraisalPerceivedValue != null &&
      min != null &&
      min > appraisalPerceivedValue)
  ) {
    return <ChevronsDown size={size} color={customPalette.orange500} />;
  } else {
    return <Minus size={size} color={customPalette.gray400} />;
  }
};
